import * as React from "react";
import {PageTitle} from "../../components/TitleBar/PageTitle";
import RefinitivContainer from "./RefinitivContainer";
import RefinitivTable from "../../components/Refinitiv/Table/RefinitivTable";

export default () => {
    return (
        <RefinitivContainer>
            <PageTitle pageTitle="Collection Statuses"/>
            <RefinitivTable key="collections" mode="collectionStatuses"/>
        </RefinitivContainer>
    )
}